module.exports = __webpack_public_path__ + "img/ict.aa141d67.png";